export const types = {
  ADD_FOCUS_BLOCK_TASK: 'ADD_FOCUS_BLOCK_TASK',
  ADJUST_FOCUS_BLOCK_RANKS: 'ADJUST_FOCUS_BLOCK_RANKS',
  REMOVE_FOCUS_BLOCK_TASK: 'REMOVE_FOCUS_BLOCK_TASK',
  SET_FOCUS_BLOCK_TASKS: 'SET_FOCUS_BLOCK_TASKS',
  SET_SPRINT_COMPOSER_DRAGGING: 'SET_SPRINT_COMPOSER_DRAGGING',
  UPDATE_FOCUS_BLOCK_TASK: 'UPDATE_FOCUS_BLOCK_TASK',
}
